// Current legal document versions — bump when policy text changes materially
export const CURRENT_PRIVACY_VERSION = "privacy-v2026.08";
export const CURRENT_TERMS_VERSION = "terms-v2026.08";
export const CURRENT_CONSENT_VERSION = `${CURRENT_PRIVACY_VERSION}+${CURRENT_TERMS_VERSION}`;
